<template>
  <div class="navigation-arrows">
    <div class="arrow left" @click="PreviousStep">
      <ArrowRight />
    </div>
    <div class="arrow right" @click="NextStep">
      <ArrowRight />
    </div>
  </div>
</template>

<script>
import ArrowRight from "@/assets/Icons/ArrowRight.vue";

export default {
  name: "StepIndicator",
  components: {
    ArrowRight
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 3
    }
  },
  data() {
    return {
      steps: ["Onboarding", "Storytelling", "Experience", "Community"],
      showTooltip: false,
      tooltipIndex: 0
    };
  },
  computed: {
    tooltipStyle() {
      // Calculate position of tooltip based on the currentStep
      const left = (this.currentStep * 107) - 100 + 'px'; // Assuming each step is 70px wide
      return { left };
    }
  },
  mounted() {
    this.showTooltip = true; // Show tooltip when component is mounted
  },
  methods: {
    NextStep() {
      this.$emit('forward-event');
    },
    PreviousStep() {
      this.$emit('back-event');
    },
  }
};
</script>

<style lang='scss' scoped>
.navigation-arrows {
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
  pointer-events: none;
  z-index: 100;
}

.arrow {
  width: 48px;
  height: 48px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  pointer-events: auto;

  &:hover {
    animation: pulse 2s infinite;
  }

  &.left {
    transform: rotate(180deg);
  }
}

@media (max-width: 768px) {
  .navigation-arrows {
    padding: 0 1rem;
  }

  .arrow {
    width: 40px;
    height: 40px;
  }
}
</style>